import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';
import { staticURL } from 'core/url';
import { getWhitelabelConfig } from 'core/whitelabel';

import { MainWrapper } from 'legacyComponents/styled/lib';
import DocumentHead from 'legacyComponents/documentHead';
import { CardSection } from 'legacyComponents/layout/cardSection';
import { ProjectCard } from 'legacyComponents/cards/types/project';
import { ProfileCard } from 'legacyComponents/cards/types/profile';

import { TabsWrapper, Tabs, Tab, LinkTabStyled } from 'apps/components/shared';

import Header from 'apps/components/header/header';

import { MicroSiteHero } from 'apps/microSite/singlePage/views/hero';
import { SinglePageMicroSiteManager } from 'apps/microSite/singlePage/appManager';

@withNamespaces()
@inject('routerStore')
@observer
export class SinglePageMicroSite extends React.Component {
  UNSAFE_componentWillMount() {
    this.appManager = new SinglePageMicroSiteManager(null, this.props);
  }

  render() {
    const { routerStore, t } = this.props;
    const whitelabelConfig = getWhitelabelConfig();

    const sections = [];
    whitelabelConfig.pages.home.homeSections.forEach(section => {
      if (section === 'featuredProjects') {
        sections.push(
          <CardSection
            title={t(whitelabelConfig.pages.home.featuredProjects.title)}
            subTitle=' '
            ownerName={whitelabelConfig.shortTitle || whitelabelConfig.title}
            cardApp={this.appManager.featuredProjectsConn.arrayApp}
            CardComponent={ProjectCard}
            noDataCardType='project'
            first={
              whitelabelConfig.pages.home.homeSections.indexOf(
                'featuredProjects',
              ) === 0
            }
            owner
            isWhitelabel
            gridColumns={3}
          />,
        );
      }
      if (section === 'projects') {
        sections.push(
          <CardSection
            title={t('Projects')}
            tooltip={t('Create new project')}
            subTitle={' '}
            ownerName={whitelabelConfig.shortTitle || whitelabelConfig.title}
            cardApp={this.appManager.projectsConn.arrayApp}
            CardComponent={ProjectCard}
            noDataCardType='project'
            first={
              whitelabelConfig.pages.home.homeSections.indexOf('projects') === 0
            }
            owner
            isWhitelabel
            gridColumns={3}
          />,
        );
      }
      if (section === 'organisations') {
        sections.push(
          <CardSection
            title={t('Organisations')}
            subTitle={' '}
            ownerName={whitelabelConfig.shortTitle || whitelabelConfig.title}
            cardApp={this.appManager.initiativesConn.arrayApp}
            CardComponent={ProfileCard}
            noDataCardType='profile'
            first={
              whitelabelConfig.pages.home.homeSections.indexOf(
                'organisations',
              ) === 0
            }
            last
            owner
            isWhitelabel
            gridColumns={3}
          />,
        );
      }
    });

    const tabs =
      whitelabelConfig.tabs &&
      whitelabelConfig.tabs.length &&
      whitelabelConfig.tabs.map(tab => {
        return (
          <Tab key={tab.name} active={routerStore.route.name === tab.path}>
            <LinkTabStyled name='' params={{}}>
              <Trans>{tab.name}</Trans>
            </LinkTabStyled>
          </Tab>
        );
      });

    return (
      <>
        <DocumentHead
          title={whitelabelConfig.title}
          description={whitelabelConfig.description}
          imagePath={whitelabelConfig.logo}
        />
        <main>
          <Header />
          <MicroSiteHero
            logo={staticURL(whitelabelConfig.logoWhite)}
            title={<Trans>{whitelabelConfig.title}</Trans>}
            description={<Trans>{whitelabelConfig.description}</Trans>}
          />
          <MainWrapper marginTop='1rem' marginBottom='40px'>
            {tabs && (
              <TabsWrapper>
                <Tabs>{tabs}</Tabs>
              </TabsWrapper>
            )}
            {sections}
          </MainWrapper>
        </main>
      </>
    );
  }
}

SinglePageMicroSite.propTypes = {
  params: PropTypes.object,
  routeName: PropTypes.string,
  routerStore: PropTypes.object,
  t: PropTypes.func,
};
